import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsClientContractTerm } from '~/hooks';

type Args = {
  /** 利用企業 ID */
  clientId: number;
};

type IUseClientContractTermDetail = (args: Args) => {
  state: {
    /** API レスポンス（data をそのまま渡す） */
    data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200;
  };
};

/**
 * 企業契約期間 詳細のコンポーネントフック
 *
 * - threeLetterCode を Cookie から取得し、API hook に渡す
 * - API hook の data をそのまま state として返す
 * - termId による絞り込み・整形は converter（logics/convertToPresentationProps）の責務
 */
export const useClientContractTermDetail: IUseClientContractTermDetail = ({ clientId }) => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsClientContractTerm({
    threeLetterCode,
    clientId,
  });

  return {
    state: { data },
  };
};
